import React from "react";
import Modal from "react-animated-modal";
import cogoToast from "cogo-toast";

import { CSSTransition, TransitionGroup } from "react-transition-group";
const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400
  },
  radioButton: {
    marginBottom: 16
  }
};

class LiveStream extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quiz_list: [],
      error: "",
      optionSelected: "",
      question_list: {
        question_title: "",
        question_media: [
          {
            media_path: ""
          }
        ],
        question_options: [
          {
            option_name: "",
            option_id: ""
          }
        ]
      },
      quiz_data: {
        quiz_title: "",
        quiz_question_list: [
          {
            main_question_id: "",
            question_title: "",
            question_media: [
              {
                media_path: ""
              }
            ],
            options_list: [
              {
                option_name: "",
                question_option_id: ""
              }
            ]
          }
        ]
      },
      ans: [],
      count: 0,
      rightAns: "none",
      wrongAns: "none",
      date: 0,
      quiz_answers: []
    };
  }
  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
    localStorage.removeItem("quiz");
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  componentDidUpdate(prevProps) {
    if (this.props.open !== prevProps.open) {
      this.setState({ quiz_list: this.props.quizs, count: 0 });
      console.log(this.state.quiz_list);
    }
    if (this.props.pause_at !== prevProps.pause_at) {
      var find = this.find(this.props.pause_at);
      console.log(this.props.pause_at);
      console.log(find);
      this.setState({ quiz_data: find, start: this.state.date });
    }
  }
  find = id => {
    return this.props.quizs.find(item => {
      //  return this.state.quiz_list.find((item)=>{
      return parseInt(item.pause_at, 10) === parseInt(id, 10);
    });
  };
  nextQue = () => {
    const allRadioButtons = document.querySelectorAll(".radio-button");

    if (this.state.optionSelected === "") {
      this.setState({ error: "Please Select One Answer " });
    } else {
      this.setState({ ans: this.state.optionSelected });
      var ans = this.findAns(this.state.optionSelected);
      let quiz = this.state.quiz_answers;
      let obj = {};
      obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
      obj.course_unit_id = this.props.main_course_unit_id;
      obj.coursemaster_id = this.props.coursemaster_id;
      obj.question_id = this.state.quiz_data.quiz_question_list[
        this.state.count
      ].main_question_id;
      obj.start_time = this.state.start;
      obj.no_of_attempted = 1;
      obj.total_point = 5;
      if (this.state.ans == 1) {
        this.setState({ rightAns: "block", wrongAns: "none" });
        obj.answer_id = this.state.optionSelected;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 5;
      } else {
        this.setState({ rightAns: "none", wrongAns: "block" });
        obj.answer_id = this.state.optionSelected;
        obj.obtained_score = 0;
        obj.accuracy =
          (100 * 0) / this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 0;
      }
      obj.time_spent_duration =
        parseInt(this.state.date) - parseInt(this.state.start);
      obj.total_score = this.state.quiz_data.marks_for_correct_answer;
      obj.end_time = this.state.date;
      quiz.push(obj);
      console.log(quiz);
      this.setState({ quiz_answers: quiz });
      localStorage.setItem("quiz", JSON.stringify(quiz));

      this.setState({ count: this.state.count + 1 });
      this.setState({ optionSelected: "" });
      this.setState({ rightAns: "none", wrongAns: "none" });

      if (document.querySelector(".selected-radio")) {
        document
          .querySelector(".selected-radio")
          .classList.remove("selected-radio");
      }
      // event.target.classList.remove('selected-radio')
      for (let i = 0; i < allRadioButtons.length; i++) {
        allRadioButtons[i].classList.remove("disabled");
      }
    }
  };

  playCorrectAudio = () => {
    document.querySelector(".correct-audio").play();
  };
  playIncorrectAudio = () => {
    document.querySelector(".incorrect-audio").play();
  };

  findAns = ans => {
    return this.state.quiz_data.quiz_question_list[
      this.state.count
    ].options_list.find(item => {
      return parseInt(item.question_option_id, 10) === parseInt(ans, 10);
    });
  };
  onSave = () => {
    if (this.state.optionSelected === "") {
      this.setState({ error: "Please Select One Answer" });
    } else {
      this.setState({ ans: this.state.optionSelected });
      var ans = this.findAns(this.state.optionSelected);
      let quiz = this.state.quiz_answers;
      let obj = {};
      obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
      obj.course_unit_id = this.props.main_course_unit_id;
      obj.coursemaster_id = this.props.coursemaster_id;
      obj.question_id = this.state.quiz_data.quiz_question_list[
        this.state.count
      ].main_question_id;
      obj.start_time = this.state.start;
      obj.no_of_attempted = 1;
      obj.total_point = 5;
      if (this.state.ans == 1) {
        this.setState({ rightAns: "block", wrongAns: "none" });
        obj.answer_id = this.state.optionSelected;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 5;
      } else {
        this.setState({ rightAns: "none", wrongAns: "block" });
        obj.answer_id = this.state.optionSelected;
        obj.obtained_score = 0;
        obj.accuracy =
          (100 * 0) / this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 0;
      }
      obj.time_spent_duration =
        parseInt(this.state.date) - parseInt(this.state.start);
      obj.total_score = this.state.quiz_data.marks_for_correct_answer;
      obj.end_time = this.state.date;
      quiz.push(obj);
      console.log(quiz);
      this.setState({ quiz_answers: quiz });
      localStorage.setItem("quiz", JSON.stringify(quiz));
      setTimeout(() => {
        this.props.close();
        this.setState({ optionSelected: "" });
        this.setState({ rightAns: "none", wrongAns: "none" });
      }, 1000);
    }
  };
  onOptionSelection = event => {
    event.target.classList.add("selected-radio");
    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    this.setState({ error: "" });
    this.setState({ optionSelected: event.target.value });
    this.setState({ rightAns: "none", wrongAns: "none" });
    this.setState({ ans: this.state.optionSelected });
    // var ans = this.findAns(event.target.id);
    let quiz = this.state.quiz_answers;
    let obj = {};
    obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
    obj.course_unit_id = this.props.main_course_unit_id;
    obj.coursemaster_id = this.props.coursemaster_id;
    obj.question_id = this.state.question_list.main_question_id;
    obj.start_time = this.state.start;
    obj.no_of_attempted = 1;
    obj.total_point = 5;
    if (event.target.getAttribute("data") == 1) {
      this.setState({ rightAns: "block", wrongAns: "none" });
      obj.answer_id = event.target.id;
      obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
      obj.accuracy =
        (100 * this.state.quiz_data.marks_for_correct_answer) /
        this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 5;

      this.playCorrectAudio();

      cogoToast.success("Correct", { position: "top-center" });
      var fullscreen = document.querySelector('.fullscreen-enabled')
      var ctContainer = document.querySelector('#ct-container')
      if (fullscreen) {
        fullscreen.appendChild(ctContainer)
      }

      setTimeout(() => {
        if (
          this.state.count + 1 < this.state.quiz_data.quiz_question_list.length
        ) {
          this.nextQue();
          if (document.querySelector(".selected-radio")) {
            document
              .querySelector(".selected-radio")
              .classList.remove("selected-radio");
          }
          for (let i = 0; i < allRadioButtons.length; i++) {
            allRadioButtons[i].classList.remove("disabled");
          }
        } else {
          this.props.close()
        }
      }, 3500);
    } else {
      cogoToast.error("Wrong", { position: "top-center" });
      var fullscreen = document.querySelector('.fullscreen-enabled')
      var ctContainer = document.querySelector('#ct-container')
      if (fullscreen) {
        fullscreen.appendChild(ctContainer)
      }
      this.setState({ rightAns: "none", wrongAns: "block" });
      obj.answer_id = event.target.id;
      obj.obtained_score = 0;
      obj.accuracy = (100 * 0) / this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 0;

      const allRadioButton = document.querySelectorAll(".radio-button");
      this.playIncorrectAudio();
      setTimeout(() => {
        if (
          this.state.count + 1 < this.state.quiz_data.quiz_question_list.length
        ) {
          this.nextQue();
          if (document.querySelector(".selected-radio")) {
            document
              .querySelector(".selected-radio")
              .classList.remove("selected-radio");
          }
          for (let i = 0; i < allRadioButtons.length; i++) {
            allRadioButtons[i].classList.remove("disabled");
          }
        } else {
          this.props.close()
        }
      }, 3500);
    }
    obj.time_spent_duration =
      parseInt(this.state.date) - parseInt(this.state.start);
    obj.total_score = this.state.quiz_data.marks_for_correct_answer;
    obj.end_time = this.state.date;
    if (localStorage.getItem("quiz")) {
      var cart = [];
      cart = JSON.parse(localStorage["quiz"]);
      cart.push(obj);
      localStorage.setItem("quiz", JSON.stringify(cart));
    } else {
      var arra = [];
      arra.push(obj);
      localStorage.setItem("quiz", JSON.stringify(arra));
    }
  };
  render() {
    const { open } = this.props;
    return (
      <Modal
        visible={open}
        closemodal={() => this.props.close()}
        type="flipInX"
      >
        <TransitionGroup>
          <CSSTransition
            key={this.state.index}
            timeout={1000}
            classNames="messageout"
          >
            <div className="modal-content border rounded quiz_sentence_type new-quiz width-730 model-responsive">
              <div className="modal-body">
                <div className="heading-block border-bottom mb-3">
                  <h3
                    className="text-4 text-black m-0 question-quiz text-center"
                    dangerouslySetInnerHTML={{
                      __html: this.state.quiz_data.quiz_question_list[
                        this.state.count
                      ].question_title
                    }}
                  ></h3>
                </div>
                <div className="row inner-game-container mx-auto">
                  <div className="col-md-6">
                    <figure
                      className="m-auto text-center"
                      style={{ opacity: this.state.opacity }}
                    >
                      {this.state.quiz_data.quiz_question_list[this.state.count].question_media !== null && this.state.quiz_data.quiz_question_list[this.state.count].question_media !== undefined && this.state.quiz_data.quiz_question_list[this.state.count].question_media !== [] && this.state.quiz_data.quiz_question_list[this.state.count].question_media.length > 0 ? this.state.quiz_data.quiz_question_list[this.state.count].question_media.map(media => (
                        <img
                          alt=""
                          className="img-thumbnail img-fluid img-category"
                          src={media.media_path ? media.media_path : "https://skillgamesacademy.com/beta/bundles/newskills/uploads/sg1/question/2018_07_18_12_17_44_headphone.png"}
                        />
                      ))
                        : null}
                    </figure>
                  </div>
                  <div className="text-center text-danger text-3">
                    <span> {this.state.error} </span>
                  </div>
                  <div className="col-md-6">
                    <div className="radio-div d-flex justify-content-center align-items-center flex-column">
                      {this.state.quiz_data.quiz_question_list[
                        this.state.count
                      ].options_list.map((op, key) => (
                        <div
                          class="radio-button shadow-sm"
                          id={key}
                          onClick={this.onOptionSelection.bind(this)}
                          data={op.right_answer ? op.right_answer : op.correct_ans_flag_value ? op.correct_ans_flag_value : null}
                        >
                          {op.option_name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="modal-footer">
                {
                  this.state.count + 1 <= this.state.quiz_data.quiz_question_list.length - 1
                    ?
                    <button
                      type="button"
                      style={{
                        backgroundColor: "#375b8d",
                        borderColor: "#375b8d"
                      }}
                      className="btn btn-rounded btn-v-3 btn-h-3 font-weight-bold text-color-light nxt-btn"
                      onClick={this.nextQue}
                    >
                      Next
                  </button>
                    :
                    this.state.isLoading
                      ?
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#375b8d",
                          borderColor: "#375b8d"
                        }}
                        className="btn btn-rounded btn-v-3 btn-h-3 font-weight-bold text-color-light nxt-btn"
                        disabled
                      >
                        Loading
                  </button>
                      :
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#375b8d",
                          borderColor: "#375b8d"
                        }}
                        className="btn btn-rounded btn-v-3 btn-h-3 font-weight-bold text-color-light nxt-btn"
                        onClick={this.onSave}
                      >
                        Save and Close
                  </button>
                }
              </div>
             */}
            </div>
          </CSSTransition>
        </TransitionGroup>
        <audio className="correct-audio" autoplay>
          <source src="./audio/correct2.mp3" type="audio/ogg" />
          <source src="./audio/correct2.mp3" type="audio/mpeg" />
        </audio>
        <audio className="incorrect-audio" autoplay>
          <source src="./audio/incorrect3.mp3" type="audio/ogg" />
          <source src="./audio/incorrect3.mp3" type="audio/mpeg" />
        </audio>
      </Modal>
    );
  }
}
export default LiveStream;
